import { AuthService } from './../../auth.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  headers = HttpHeaders;
  api_url = 'user';
  profileUpdater = new Subject();
  constructor(private http: HttpClient, private authService: AuthService) {}

  // get profile details
  get_profile_details() {
    return this.authService.apiGet(this.api_url, null);
  }

  updateProfile() {
    this.profileUpdater.next(true);
  }
}
